import axios from "axios"

export const commonrequest = async (methods, url, body, header) => {
    let config = {
        method: methods,
        url,
        headers: header ? header
            : {
                "Content-Type": "application/json"
            },
        data: body
    }

    try {
        const { data, status } = await axios(config);
        return { data, status };
    } catch (error) {
        // return both status and backend error
        return {
            status: error.response?.status,
            error: error.response?.data?.error || "Something went wrong"
        };
    }
}
